import React from 'react';

export default function LoadingSvg() {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ animation: "reusable-toast-spin 0.8s linear infinite" }}
        >
            <style>
                {`@keyframes reusable-toast-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}
            </style>
            <circle cx="12" cy="12" r="9" stroke="#e0e0e0" strokeWidth="3" fill="none" />
            <path
                d="M21 12a9 9 0 0 0-9-9"
                stroke="#0097D7"
                strokeWidth="3"
                strokeLinecap="round"
                fill="none"
            />
        </svg>
    );
}
